var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/169c843e2a0c439b4aa1fbc73b588a01.js').default;

var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d0caa29dcf7caf1c9d21b176bfccbce.js').default;

var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d308a02342b4f8320a1259a73bdb4d1.js').default;

var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/230cf79e474e03dad31f043814ac0ccd.js').default;

var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28898a5172564c9946341cd537e8088e.js').default;

var scope_5 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/331a404bc6d2f6dbc15e527dd78adbb5.js').default;

var scope_6 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3388b24087f30d71a9c4d31631120223.js').default;

var scope_7 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5773867a9d22729f0af08329f92d84bf.js').default;

var scope_8 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/63ee4b283805c4a50947be7df4e009a9.js').default;

var scope_9 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/666b5cce47e8cb3974237b517f0f4b53.js').default;

var scope_10 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/779e50b01813f0f055a384eff7b2b59a.js').default;

var scope_11 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8161bc793e1f908e8efc664fbf70ce0f.js').default;

var scope_12 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a18a0caf1429c34ebbf242812faf410a.js').default;

var scope_13 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/da945b4c298b54252f7f52143431f775.js').default;

var scope_14 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd27d5c596eda6f051c88027fdff8181.js').default;

var scope_15 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/de8edc2df397e0cccd41289ddb2c2064.js').default;

var scope_16 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_17 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd8a5d2f31d14f039a9b4e800a2eb1b5.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17);